import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_blocks/Main_redesign/Contact/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/articles/[post]/_components/ArticleImages/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/articles/[post]/_components/RelatedArticles/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/articles/[post]/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/portfolio/__strapi-blocks/_blocks/CardsGrid/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/portfolio/__strapi-blocks/_blocks/Description/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/portfolio/__strapi-blocks/_blocks/DualImgScreen/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/portfolio/__strapi-blocks/_blocks/FullScreenImg/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/portfolio/__strapi-blocks/_blocks/Gallery/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/portfolio/__strapi-blocks/_blocks/Horizontal/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/portfolio/__strapi-blocks/_blocks/ListBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/portfolio/__strapi-blocks/_blocks/MainBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/portfolio/__strapi-blocks/_blocks/NumberInfographics/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/portfolio/__strapi-blocks/_blocks/TitleBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/portfolio/__strapi-blocks/_blocks/TwoColumnsH4/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/portfolio/__strapi-blocks/_blocks/TwoColumnsParagraphs/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/portfolio/__strapi-blocks/_blocks/TwoColumnsParagraphsTitlesItems/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/StrapiContentRenderer.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Typography/styles.module.css");
